import { FC } from 'react';

type Props = {
	className?: string;
};

const MoneyIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M2 9.99997C2 7.17004 2 5.75507 2.84222 4.81039C2.97693 4.6593 3.1254 4.51956 3.28594 4.39278C4.28966 3.6001 5.79306 3.6001 8.79986 3.6001H11.1998C14.2066 3.6001 15.71 3.6001 16.7137 4.39278C16.8743 4.51956 17.0227 4.6593 17.1575 4.81039C17.9997 5.75507 17.9997 7.17004 17.9997 9.99997C17.9997 12.8299 17.9997 14.2448 17.1575 15.1895C17.0227 15.3407 16.8743 15.4803 16.7137 15.6071C15.71 16.3998 14.2066 16.3998 11.1998 16.3998H8.79986C5.79306 16.3998 4.28966 16.3998 3.28594 15.6071C3.1254 15.4803 2.97693 15.3407 2.84222 15.1895C2 14.2448 2 12.8299 2 9.99997Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M12.039 9.99996C12.039 11.1045 11.1436 11.9999 10.039 11.9999C8.93449 11.9999 8.03906 11.1045 8.03906 9.99996C8.03906 8.89542 8.93449 8 10.039 8C11.1436 8 12.039 8.89542 12.039 9.99996Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M4.39844 10H5.19842'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M14.8008 10H15.6008'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
		</svg>
	);
};

export default MoneyIcon;
